import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VopRequestRoutingModule } from './vop-request-routing-module';

import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { VopRequestComponent } from './vop-request/vop-request.component';
import { VopRequestHeaderComponent } from './vop-request-header/vop-request-header.component';
import { VopRequestNewCheckDialogComponent } from './vop-request-new-check-dialog/vop-request-new-check-dialog.component';
import { VopRequestDataComponent } from './vop-request-data/vop-request-data.component';
import { VopRequestDataTableComponent } from './vop-request-data-table/vop-request-data-table.component';
import { VopRequestFiltersComponent } from './vop-request-filters/vop-request-filters.component';
import { VopRequestFilterDialogComponent } from './vop-request-filter-dialog/vop-request-filter-dialog.component';
import { VopRequestDetailDialogComponent } from './vop-request-detail-dialog/vop-request-detail-dialog.component';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [
    VopRequestComponent,
    VopRequestHeaderComponent,
    VopRequestNewCheckDialogComponent,
    VopRequestDataComponent,
    VopRequestDataTableComponent,
    VopRequestFiltersComponent,
    VopRequestFilterDialogComponent,
    VopRequestDetailDialogComponent,
  ],
  imports: [
    CommonModule,
    VopRequestRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatMenuModule,
    MatExpansionModule,
  ],
})
export class VopRequestModule {}
